// src/components/SectorSearchBar.jsx
import { useState } from "react";
import {
  Flex,
  Input,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { normalizeSectorName } from "../utils/normalizeSectorName";

export default function SectorSearchBar({ onSearch }) {
  const [query, setQuery] = useState("");
  const toast = useToast();
  const isDev = import.meta.env.DEV;

  const handleSearch = () => {
    const cleaned = query.trim();
    const sector = normalizeSectorName(cleaned);

    if (isDev) {
      console.log("[SectorSearchBar] raw:", cleaned, "→ normalized:", sector);
    }

    if (!sector) {
      toast({
        title: "Invalid postcode",
        description:
          "Please enter a valid UK postcode or sector (e.g., PR3, FY6, BD10, PO1 3AB).",
        status: "warning",
        duration: 2500,
        isClosable: true,
      });
      return;
    }

    onSearch(sector);
  };

  return (
    <Flex gap={2} align="center">
      <Input
        placeholder="Enter Postcode (eg PR25..)"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
          }
        }}
        width="260px"
        bg="white"
        borderColor="red.300"
        _hover={{ borderColor: "red.400" }}
        _focus={{
          borderColor: "red.500",
          boxShadow: "0 0 0 1px red",
        }}
        _placeholder={{ color: "red.400" }}
      />

      <IconButton
        aria-label="Search"
        icon={<SearchIcon />}
        onClick={handleSearch}
        colorScheme="red"
        size="md"
        borderRadius="md"
      />
    </Flex>
  );
}
